import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './BannerUpdate.css';
import API_URL from '../../api/ExamCalendarApi';

const BannerUpdate = ({ pageName }) => {
  const [newPageName, setNewPageName] = useState('');
  const [imageFile, setImageFile] = useState(null); // To store the uploaded image
  const [banner, setBanner] = useState(null); // To store the fetched banner

  // Automatically fetch the banner when the component mounts or pageName changes
  useEffect(() => {
    if (pageName) {
      fetchBanner();
    }
  }, [pageName]);

  // Function to handle file input changes
  const handleFileChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  // Function to fetch banner by pageName
  const fetchBanner = async () => {
    try {
      const response = await axios.get(`${API_URL}/banner/${pageName}`);
      setBanner(response.data[0]); // Assuming you receive an array of banners
      setNewPageName(response.data[0].pageName); // Set the current pageName to edit field
    } catch (error) {
      console.error('Error fetching banner:', error);
    }
  };

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('newPageName', newPageName); // Append the new page name if updated
    if (imageFile) {
      formData.append('bannerImage', imageFile); // Append the image if provided
    }

    try {
      // Update the banner using the pageName
      await axios.put(`${API_URL}/banner/editByPageName/${pageName}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      alert('Banner updated successfully');
      setImageFile(null); // Reset the image file

      // Immediately fetch the latest banner data after the update
      fetchBanner(); // Refresh the banner details with updated data

    } catch (error) {
      console.error('Error updating banner:', error);
    }
  };

  return (
    <div className="admin-bannerupdate-container">
      {banner && (
        <>
          <div className="admin-bannerupdate-current-banner">
            {banner.imageUrl && <img src={banner.imageUrl} alt="Banner" className="admin-bannerupdate-image" />}
          </div>

          <form onSubmit={handleSubmit} className="admin-bannerupdate-form">
            <div className="admin-bannerupdate-form-group">
              <label htmlFor="bannerImage" className="admin-bannerupdate-label">New Banner Image</label>
              <input
                type="file"
                className="admin-bannerupdate-input"
                id="bannerImage"
                onChange={handleFileChange}
              />
            </div>

            <button type="submit" className="admin-bannerupdate-submit-button">Update Banner</button>
          </form>
        </>
      )}
    </div>
  );
};

export default BannerUpdate;
